import { TranslateService } from '@ngx-translate/core';
var AppComponent = (function () {
    function AppComponent(translateService) {
        this.translateService = translateService;
        this.title = 'app';
        this.defaultLang = 'en';
        if (localStorage.getItem('lang')) {
            this.defaultLang = localStorage.getItem('lang');
        }
        translateService.setDefaultLang('en');
        translateService.use(this.defaultLang);
    }
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/app.component.ts.pre-build-optimizer.js